<div class="layout-content">
  <sub-header>
    <ces-breadcrumb
      [menuItems]="securityBreadcrumbs"
      variation="design"
    ></ces-breadcrumb>
  </sub-header>

  <ces-card
    style="height: calc(100vh - 160px); overflow-y: auto"
    class="card-job-list"
  >
    <ces-card-header>
      <div class="header-grid-container d-none">
        <div class="textbx">
          <ces-textbox
            inputType="text"
            iconPosition="left"
            placeholder="Search user here..."
            icon="icon-search"
            [clearText]="false"
          ></ces-textbox>
        </div>
      </div>
    </ces-card-header>
    <ces-card-body>
      <div class="page-security-container">
        <app-security-setup></app-security-setup>
      </div>
    </ces-card-body>
    <div #container></div>
  </ces-card>
</div>
